import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { contains } from '@utiljs/dom';
import { isFunction } from '@utiljs/is';
import { Manager, Reference, PopperPortal } from '../Popper';
import { placementEnum, innerPlacement } from '../../_utils/types';
import { createChainedFunction } from '../../_utils';

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);
    _this.innerRef = null;
    _this.contentTimer = null;

    _this.toggleVisible = function () {
      _this.setState(function (state) {
        return {
          visible: !state.visible
        };
      }, function () {
        var visible = _this.state.visible;

        _this.handleVisibleChange(visible || false);
      });
    };

    _this.setVisible = function (value, eventType) {
      var visible = _this.state.visible;

      if (value === visible) {
        return;
      }

      if (_this.isControlled) {
        _this.handleMouseEvent(eventType);
      } else {
        _this.setState({
          visible: value
        }, function () {
          _this.handleVisibleChange(value);

          _this.handleMouseEvent(eventType);
        });
      }
    };

    _this.handleMouseEvent = function (eventType) {
      var _this$props = _this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave;

      switch (eventType) {
        case 'MouseEnter':
          if (isFunction(onMouseEnter)) {
            onMouseEnter();
          }

          break;

        case 'MouseLeave':
          if (isFunction(onMouseLeave)) {
            onMouseLeave();
          }

          break;

        default:
      }
    };

    _this.handleVisibleChange = function (status) {
      var onVisibleChange = _this.props.onVisibleChange;

      if (isFunction(onVisibleChange)) {
        onVisibleChange(status);
      }
    };

    _this.handleClickOutside = function (event) {
      if (!contains(_this.innerRef, event.target)) {
        if (_this.isControlled) {
          _this.handleEventClickOutside(event);
        } else {
          _this.setState({
            visible: false
          }, function () {
            _this.handleVisibleChange(false);

            _this.handleEventClickOutside(event);
          });
        }
      }
    };

    _this.handleEventClickOutside = function (event) {
      var onClickOutside = _this.props.onClickOutside;

      if (isFunction(onClickOutside)) {
        onClickOutside(event);
      }
    };

    _this.handleClick = function () {
      var _this$props2 = _this.props,
          trigger = _this$props2.trigger,
          disabled = _this$props2.disabled;
      if (disabled) return;

      if (trigger === 'click' && !_this.isControlled) {
        _this.toggleVisible();
      }
    };

    _this.handleMouseEnter = function () {
      var trigger = _this.props.trigger;

      if (trigger === 'hover' && !_this.isControlled) {
        window.clearTimeout(_this.contentTimer);
        _this.contentTimer = null;

        _this.setVisible(true, 'MouseEnter');
      }
    };

    _this.handleMouseLeave = function () {
      var trigger = _this.props.trigger;
      var visible = _this.state.visible;

      if (trigger === 'hover' && !_this.isControlled && visible) {
        /**
         * NOTE: 在 hover 时，将状态改变事件放在异步队列里去。避免在内容区和弹出框区域的重复状态改变
         * 34 为一帧的时间
         */
        _this.contentTimer = window.setTimeout(function () {
          _this.setVisible(false, 'MouseLeave');
        }, 34);
      }
    };

    _this.handleInnerRef = function (ref) {
      _this.innerRef = ref;
    };

    var defaultVisible = props.defaultVisible,
        visible = props.visible;
    _this.state = {
      visible: _this.isControlled ? visible : defaultVisible
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          content = _this$props3.content,
          placement = _this$props3.placement,
          display = _this$props3.display,
          lazy = _this$props3.lazy,
          container = _this$props3.container,
          disablePortal = _this$props3.disablePortal,
          useClone = _this$props3.useClone,
          onMouseEnter = _this$props3.onMouseEnter,
          onMouseLeave = _this$props3.onMouseLeave,
          flip = _this$props3.flip,
          className = _this$props3.className;
      var visible = this.state.visible;
      var refStyle = {
        display: display
      };
      var newProps = {};
      var child;

      if (useClone && /*#__PURE__*/React.isValidElement(children)) {
        child = React.Children.only(children);
        newProps.onClick = createChainedFunction(child.props.onClick, this.handleClick);
        newProps.onMouseEnter = createChainedFunction(child.props.onMouseEnter, this.handleMouseEnter);
        newProps.onMouseLeave = createChainedFunction(child.props.onMouseLeave, this.handleMouseLeave);
      }

      return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, {
        innerRef: this.handleInnerRef
      }, function (_ref) {
        var ref = _ref.ref;
        return useClone && /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, _Object$assign({
          ref: ref
        }, newProps)) : /*#__PURE__*/React.createElement("div", {
          ref: ref,
          style: refStyle,
          onClick: _this2.handleClick,
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave
        }, children);
      }), /*#__PURE__*/React.createElement(PopperPortal, {
        container: container,
        visible: visible,
        disablePortal: disablePortal,
        modifiers: {
          flip: {
            enabled: flip,
            flipVariationsByContent: flip === 'flip'
          },
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          }
        },
        placement: placementEnum[placement],
        onClickOutside: this.handleClickOutside,
        innerProps: {
          onMouseEnter: createChainedFunction(this.handleMouseEnter, onMouseEnter),
          onMouseLeave: createChainedFunction(this.handleMouseLeave, onMouseLeave)
        },
        className: className,
        lazy: lazy
      }, content));
    }
  }, {
    key: "isControlled",
    get: function get() {
      var visible = this.props.visible;
      return visible !== undefined && visible !== null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var visible = nextProps.visible;

      if (visible !== undefined && visible !== null) {
        return {
          visible: visible
        };
      }

      return null;
    }
  }]);

  return Popover;
}(React.Component);

Popover.propTypes = {
  trigger: PropTypes.string,
  display: PropTypes.string,
  placement: PropTypes.oneOf(innerPlacement),
  defaultVisible: PropTypes.bool,
  visible: PropTypes.bool,
  onClickOutside: PropTypes.func,
  onVisibleChange: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseEnter: PropTypes.func,
  lazy: PropTypes.bool,
  className: PropTypes.string,
  container: PropTypes.func,
  disablePortal: PropTypes.bool,
  flip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool
};
Popover.defaultProps = {
  trigger: 'click',
  placement: 'bottom',
  display: 'inline-block',
  className: undefined,
  visible: undefined,
  defaultVisible: false,
  onClickOutside: undefined,
  onVisibleChange: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  lazy: false,
  flip: true,
  container: undefined,
  disablePortal: false,
  disabled: false
};
export default Popover; // TODO:
// 宽度对齐
// ✅ clickOutside 控制
// ✅ 主动更新
// ✅ render props 性能堪忧
// ✅ 使用 resize 更新宽度
// ✅ hover 时：在按钮和弹出框之间移动会产生两次的状态变更，怎么解决？